import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {ExclamationIcon} from "src/assets/Icons";

const BASE_ICON_CLASS = "h-full w-full rounded-xl border-2 border-background-default p-3";

export default function FareQuoteError() {
  const { t } = useTranslation();
  const { searchId } = useParams();

  return (
    <div className="fixed inset-0 w-full z-50 flex items-center justify-center bg-background-inverted/40">
      <div className="relative w-96 max-w-96 flex w-full flex-col gap-4 rounded-lg p-6 shadow-sm bg-background-default">
        <div className="mb-4 h-16 w-16">
          <ExclamationIcon
            className={`${BASE_ICON_CLASS} bg-background-danger! border-none! text-font-danger!`}
          />
        </div>
        <h2 className="mb-1 text-lg font-bold">
          <span className="text-font-danger!">{t("Flights.details.fareQuoteError.failReason")}</span>
        </h2>
        <div className="flex flex-col gap-2">
          <p className="text-sm">
            <span className="text-font-subtle!">{t("Flights.details.fareQuoteError.suggestion")}</span>
          </p>
        </div>
        <div className="flex flex-col gap-2">
          <Link
            to={`/travel/tickets/${searchId}`}
            className="w-full block text-center cursor-pointer rounded-lg px-4 py-4 text-sm font-semibold transition text-font-inverted! bg-background-primary!"
          >
            {t("Flights.details.fareQuoteError.searchNewFlight")}
          </Link>
        </div>
      </div>
    </div>
  );
}
